import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import $ from 'jquery';
import AirQualityOverviewMap from './../overview/airQualityOverviewMap'
import {
    Badge,
    Button,
    ButtonDropdown,
    ButtonGroup,
    ButtonToolbar,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardTitle,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Progress,
    Row,
    Table,
    FormGroup,
    Label,
    Input
  } from 'reactstrap';

class SettingsComponent extends Component{
    constructor(props) {
        super(props);
        
        this.state = {
            
        }
      
    }

    componentDidMount(){
       $(".nav a").first().removeClass( "active" )
   
        

    }

   

    render(){
    
        return(
              <div>
            <Row>
            <Col>
             {/*  <Card>
                <CardHeader>
                 Account Settings
                </CardHeader>
                <CardBody>
                  <Row>
                  <Col xs="12" md="12" xl="6">
                    <h5>Update Personal Information</h5>
                        
                        <div className="mt-3">
                         <Label for="Username" >Username</Label>
                        
                               
                                <Input type="text" name="username" id="username" placeholder="someone" />
                           
                                </div>    
                           
                                <div className="mt-3">
                            <Label for="Email" >Email</Label>
                           
                                <Input type="email" name="email" id="email" placeholder="someone@someone.com" disabled/>
                                </div>
                                <div className="mt-4">
                                 <Button color="info" className="text-white float-right">Update</Button>{' '}
                                 </div>    
                            
                  </Col>
                  <Col xs="12" md="12" xl="6" className="password-section">
                  <h5>Change Password</h5>
                                <div className="mt-3">
                            <Label for="prevPass" >Current Password</Label>
                        
                                <Input type="password" name="prevPass" id="prevPass" placeholder="******" />
                           
                                </div>    
                           
                                <div className="mt-3">
                            <Label for="newPass1" >New Password</Label>
                           
                                <Input type="password" name="newPass1" id="newPass1" placeholder="*****" />
                                </div>   

                                  <div className="mt-3">
                            <Label for="newPass2" >Re-type New Password</Label>
                           
                                <Input type="password" name="newPass2" id="newPass2" placeholder="*****" />
                                </div>   

                                <div className="mt-4">
                                 <Button color="info" className="text-white float-right">Change Password</Button>{' '}
                                 </div> 


                  </Col>
                </Row>
                </CardBody>
                </Card> */}
                <AirQualityOverviewMap />
                </Col>
                </Row>

             
                </div>
        );

    }



}

const mapDispatchToProps = (dispatch) => {
    return {
        visit: (data) => { 
            dispatch({
                type : 'ADD_VISIT',
                payload : data
            }
            ) 
        }}
    }


const mapStateToProps = (state) => {
    return {
        organizationsReducer: state.organizationsReducer
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(SettingsComponent); 





 


// WEBPACK FOOTER //
// ./src/components/settings/settingsComponent.js